<script setup lang="ts">
import { ref } from "vue";
import { Option } from "@/types";
import { useAutocompleteScac } from "@/api/mutations";

type Props = {
  customerId: string;
  label: string;
  name?: string;
  value?: string;
};

const autocompleteScacMutation = useAutocompleteScac();

const props = defineProps<Props>();
const options = ref<Option[]>([]);
async function findScacs({ search }: { search: string }): Promise<Option[]> {
  if (!search || search.length < 2) return options.value;

  const responseData = await autocompleteScacMutation.mutateAsync({
    customerId: props.customerId,
    requestData: {
      search_term: search,
      page: 1,
      page_size: 100,
    },
  });

  if (!responseData.data.length) return options.value;

  const out: Option[] = [];
  for (const scac of responseData.data) {
    out.push({
      label: scac,
      value: scac,
    });
  }
  options.value = out;
  return options.value;
}
</script>

<template>
  <FormKit
    type="autocomplete"
    :name="name ?? 'scac'"
    :label="label"
    :options="findScacs"
    :close-on-select="true"
    :value="value"
    loader-icon="loader"
    empty-message="No matching SCAC found."
    placeholder="- -"
    :classes="{ outer: '!mb-0', wrapper: '!mb-0' }"
  />
</template>
